'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = {
    DevTool: function DevTool() {
      return null;
    }
  };
} else {
  module.exports = require('./index.cjs.development.js');
}